<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents.html" xml:lang="en-US">
<div class="Basic-Text-Frame-1">
<p class="TOCtitle">Contents</p>
<p class="TOCitem"><a href="#/Chapter_One#Anchor-1">CHAPTER ONE</a></p>
<p class="TOCitem"><span href="#/Chapter_Two#Anchor-1" title="Link target outside of Sample">CHAPTER TWO</span></p>
<p class="TOCitem"><span href="#/Chapter_Three#Anchor-1" title="Link target outside of Sample">CHAPTER THREE</span></p>
<p class="TOCitem"><span href="#/Chapter_Four#Anchor-1" title="Link target outside of Sample">CHAPTER FOUR</span></p>
<p class="TOCitem"><span href="#/Chapter_Five#Anchor-1" title="Link target outside of Sample">CHAPTER FIVE</span></p>
<p class="TOCitem"><span href="#/Chapter_Six#Anchor-1" title="Link target outside of Sample">CHAPTER SIX</span></p>
<p class="TOCitem"><span href="#/Chapter_Seven#Anchor-1" title="Link target outside of Sample">CHAPTER SEVEN</span></p>
<p class="TOCitem"><span href="#/Chapter_Eight#Anchor-1" title="Link target outside of Sample">CHAPTER EIGHT</span></p>
<p class="TOCitem"><span href="#/Chapter_Nine#Anchor-1" title="Link target outside of Sample">CHAPTER NINE</span></p>
<p class="TOCitem"><span href="#/Epilogue#Anchor-1" title="Link target outside of Sample">EPILOGUE</span></p>
<p class="TOCitem"><span href="#/Excerpt#Anchor-1" title="Link target outside of Sample">EXCERPT FROM <em>CROWN PRINCE'S CHOSEN BRIDE</em> BY KANDY SHEPHERD</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?53d4501c